module.exports = __webpack_public_path__ + "static/media/add_active.4e2917bf.svg";